import { createContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const FiltersContext = createContext({
  data: null,
  setData: () => {},
  openDrawer: null,
  setOpenDrawer: () => {},
  drawerContent: null,
  setDrawerContent: () => {},
  drawerTitle: null,
  setDrawerTitle: () => {},
  hasBack: null,
  setHasBack: () => {},
  drawerTitleExtraComponents: null,
  setDrawerTitleExtraComponents: () => {}
});

function NRReportFilterContextWrapper({ children }) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerContent, setDrawerContent] = useState([]);
  const [hasBack, setHasBack] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState([]);
  const [drawerTitleExtraComponents, setDrawerTitleExtraComponents] = useState();
  const [data, setData] = useState();
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState(location.pathname);

  // Handle location changes to close drawer
  useEffect(() => {
    if (location.pathname !== previousLocation && openDrawer) {
      setOpenDrawer(false);
    }
    setPreviousLocation(location.pathname);
  }, [location.pathname]);

  // --- THIS IS THE KEY CHANGE ---
  // Effect to clean up all drawer-related state when it closes.
  // This is the correct place to handle cleanup, as it's tied to the
  // actual state of the drawer (`openDrawer`) rather than a component's
  // lifecycle, which prevents issues with React 18's Strict Mode.
  useEffect(() => {
    if (!openDrawer) {
      setDrawerContent([]);
      setDrawerTitle('');
      setDrawerTitleExtraComponents(null);
      setData(null);
      setHasBack(false);
    }
  }, [openDrawer]); // This effect depends only on the drawer's open/closed state.

  const defaultValues = {
    data,
    setData,
    openDrawer,
    setOpenDrawer,
    drawerContent,
    setDrawerContent,
    drawerTitle,
    setDrawerTitle,
    hasBack,
    setHasBack,
    drawerTitleExtraComponents,
    setDrawerTitleExtraComponents
  };

  return <FiltersContext.Provider value={defaultValues}>{children}</FiltersContext.Provider>;
}

export default NRReportFilterContextWrapper;
